import styles from './product-tour.css?url'
import youtubeLiteStyles from './yt-lite.css?url'

export const links = () => [
  { rel: 'stylesheet', href: styles },
  { rel: 'stylesheet', href: youtubeLiteStyles },
]

export { CalcsTour } from './calcs-tour'
export { DataModelingTour } from './data-modeling-tour'
